import { IOption } from 'app/components'

/**
 * RQE (registro de qualificação de especialista) é exclusivo de médico. Todo profissional de saúde usa o
 * cargo "Profissional de Saúde" e a profissão vem do conselho escolhido; o RQE só vale com CRM.
 * As opções de conselho têm rótulo "SIGLA - Nome".
 */
export const isConselhoMedicina = (conselho?: IOption<number> | null) =>
  (conselho?.label || '').split(' - ')[0].trim().toUpperCase() === 'CRM'
